module.exports = __webpack_public_path__ + "media/sxxzw.8cb5aa5d.mp4";